// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2Fxgz","noInteraction":"EventWrapper_noInteraction__7RgKu"};